import { Checkbox, CheckboxChangeEvent } from "antd"

export const CheckboxControl = ({
  label,
  value,
  onChange
}: {
  label: string
  value?: boolean
  onChange?: (value: boolean) => void
}) => {

  const handleChange = (e: CheckboxChangeEvent) => {
    onChange?.(e.target.checked)
  }
  
  return (
      <Checkbox checked={!!value} onChange={handleChange}>{label}</Checkbox>
  )
}